import React,{ useState } from "react";

//import Layout from "../Layout/Layout";
import pageData from "../PageData";
const cifclTa = () => {
	const [letterHeadHeaderUrl,setLetterHeadHeaderUrl] = useState("/assets/images/letterHeadHeader.jpg");
	const [letterHeadFooterUrl,setLetterHeadFooterUrl] = useState("/assets/images/letterHeadFooter.png");
	const [propSignUrl,setPropSignUrl] = useState("/assets/images/prop_sign.png");
	const [taDate,setTaDate] = useState("15/11/2023");
	const [taAmount,setTaAmount] = useState("1000000");
	const [taAmountInWord,setTaAmountInWord] = useState("Ten Lac");
	
	return(
	   <div className="container">
	   <div className="d-print-none">
	   <form>
  <div className="mb-3">
    <label for="taDate" className="form-label">TA Date</label>
    <input type="date" className="form-control" id="taDate" />
    
  </div>
  <div className="mb-3">
    <label for="taAmount" className="form-label">Amount</label>
    <input type="number" className="form-control" id="taAmount"/>
  </div>
  <div className="mb-3 form-check">
    <input type="checkbox" className="form-check-input" id="exampleCheck1"/>
    <label className="form-check-label" for="exampleCheck1">Check me out</label>
  </div>
  <button type="submit" className="btn btn-primary">Submit</button>
</form>
	   
	   </div>
	   <br/>
	   <div className="text-end ">
                            <img className='' width='190' height="46" src={letterHeadHeaderUrl} alt='HeaderImage'/>
                        </div><br/><br/><br/>
		    To,<div className="text-end ">Date :{taDate} </div>

The Manager,<br/>
Cholamandalam Investment and Finance Co Ltd,<br/>
Dere House, NSC Bose Road,<br/>
           Chennai<br/>
<br/><br/>


Subject-Trade Advance of Rs.{taAmount}/-&nbsp;to M/S {pageData.companyName}<br/><br/>


            Dear Sir,<br/>
With Reference to above said subject, We request to please transfer Rs. {taAmount}/-&nbsp;({taAmountInWord}&nbsp;Only) as Trade Advance against our new vehicle. Please make payment in favor of Piaggio Vehicles Pvt. Ltd. Bank details are given below.<br/><br/>
<table class="table table-bordered">
  
  <tbody>
    <tr>
      
      <td>BENEFICIARY NAME</td>
      <td>Piaggio Vehicles Pvt. Ltd</td>
    </tr>
    <tr>
     
      <td>BANK NAME</td>
      <td>HSBC BANK</td>
    </tr>
	 <tr>
      
      <td>ACCOUNT NUMBER</td>
      <td>PIAGGIO1IN48AA509V</td>
    </tr>
	 <tr>
      
      <td>BRANCH ADDRESS</td>
      <td>BUND GARDEN ROAD,PUNE</td>
    </tr>
	 <tr>
      
      <td>BRANCH IFSC CODE</td>
      <td>HSBC0411002</td>
    </tr>
    
  </tbody>
</table><br/><br/>

Thanks with Regards<br/>
	
<div className="text-start ">
                            <img className='' width='142' height="56" src={propSignUrl} alt='PropSignImage'/>
                        </div>
						                            {pageData.companyName}<br/><br/><br/><br/><br/>
													<div className="text-start ">
                            <img className='' width='702' height="73" src={letterHeadFooterUrl} alt='letterHeadFooterImage'/>
                        </div>
													
													
													


		</div>
		
	
	
	
	);
}
export default cifclTa;